import * as React from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: 831, height: 831, overflow: "hidden", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M597.66 184.735 174.96 750.83h552.62ZM635.63 0 831 831H0Z" }));
export default SvgTriangle;
